import * as React from "react"
import { Box } from "@mui/material"
import { SelectSeeker } from "@ui-seeker/core"


export default function SkuDetailsPricingEvolutionActions({ onChange, options, value }) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
		 <SelectSeeker
            options={options}
            label="Group By"
            sx={{ width: 150}}
            value={value}
            onChange={onChange}
	    />
	</Box>
}